module.exports = __webpack_public_path__ + "static/media/mob_loading.870750ac.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/mob_loading.gif
 ** module id = 648
 ** module chunks = 0
 **/